import React, { Component } from "react";
import { toast } from "react-toastify";
import { forgot } from "../../api/auth";
import { showSpinner, hideSpinner } from "../../components/App/App";

export default class Restore extends Component {
  state = {
    form: {}
  };

  onFormSubmit(event) {
    event.preventDefault();
    if (this.state.form.password !== this.state.form.rePassword) {
      return toast.error("Пароли не совпадают");
    }

    showSpinner();
    forgot(this.state.form)
      .then(data => {
        hideSpinner();
        toast.info("Письмо для подтверждения отправлено на почту");
        this.props.history.push("/" + window.location.search);
      })
      .catch(data => {
        hideSpinner();
        toast.error("Пользователь с данным email не найден");
      });
  }

  onFormDataChange(event) {
    this.setState({
      form: {
        ...this.state.form,
        [event.target.name]: event.target.value
      }
    });
  }

  render() {
    return (
      <div className="wrapper style1 fullscreen fade-up">
        <div className="card card-sign-action">
          <article className="card-body mx-auto sign-up-block">
            <h1 className="card-title mt-3 text-center">
              Восстановление доступа
            </h1>

            <form className="mt-2" onSubmit={this.onFormSubmit.bind(this)}>
              <div className="form-group input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-user" />
                  </span>
                </div>
                <input
                  name="username"
                  className="form-control"
                  placeholder="Email"
                  required
                  onChange={this.onFormDataChange.bind(this)}
                  type="text"
                />
              </div>
              <div className="form-group input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-user" />
                  </span>
                </div>
                <input
                  name="password"
                  className="form-control"
                  placeholder="Пароль"
                  required
                  onChange={this.onFormDataChange.bind(this)}
                  type="password"
                />
              </div>
              <div className="form-group input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-user" />
                  </span>
                </div>
                <input
                  name="rePassword"
                  className="form-control"
                  placeholder="Повтор пароля"
                  required
                  onChange={this.onFormDataChange.bind(this)}
                  type="password"
                />
              </div>
              <div className="form-group">
                <button
                  type="submit"
                  className="btn btn-success btn-block"
                  style={{ width: "100%" }}
                >
                  Отправить
                </button>
              </div>
            </form>
          </article>
        </div>
      </div>
    );
  }
}
